module.exports = __webpack_public_path__ + "static/img/default.df02321c.jpg";